import Component from 'gia/Component'
import _each from 'lodash.foreach'
import Observer from '../components/observer';




class Percent extends Component {

  constructor(element) {

    super(element)

    this.body = document.body
    this.element = element
   // this.i = 0


    this.ref = {
      item: []
    }

  }

  mount() {

     this.observer = new Observer({
       rootMargin: '20% 0% -20% 0%'
     });
     this.observer.add(this.ref.item);



    }    



    resize(){

       


       

    }

    unmount() {



    }

}

module.exports = Percent



